import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-226" data-mp="1mmh6abszb4gw">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-227" data-mp="1hph2y8nikfth">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-228" data-mp="ty1vk1gvr8bd">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-229" data-mp="u0xvtwg7a92z">
            Scopri il tuo pacchetto completo <em className="text-red-300" data-id="element-230" data-mp="13wrgy47zjawd">ARTE PRONTA™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-231" data-mp="13uoe2jlqhna8">
            Prepara un Intero Anno di Lezioni di Arte in soli 5 Minuti.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-232" data-mp="2fav9r72u6szu" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-233" data-mp="2affuqbt3er1u">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-234" data-mp="ui8y84f6ugjv">Il pacchetto completo contiene</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-235" data-mp="zjg6s5p5njrl">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-236" data-mp="13ip1bcs0rlo7">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-237" data-mp="6u9918xiyy7e">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-238" data-mp="bs0wnqr4zy5s" />
                </span>
                <span data-id="element-239" data-mp="ftmb3gjbkki3">
                  <span className="block font-medium leading-snug" data-id="element-240" data-mp="fsb477ukuwmr">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-241" data-mp="kmp6zvbkk61g">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-242" data-mp="3o9fpnpu3blwi">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-243" data-mp="vdw7gagsuwhs">Prezzo di lancio</p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-244" data-mp="qgdzoneiqnbd">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-245" data-mp="105xm231fwzaz">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-246" data-mp="chxu4zse72ut" />
            Pagamento unico. Nessun abbonamento.
          </p>

          <CtaButton label="Ottieni tutto il pacchetto ora" className="mt-8 w-full" data-id="element-247" data-mp="7jmhkhapqe8w" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-248" data-mp="lj4drhqc8tsa">
            {offerIncludes.map(item => <li key={item} data-id="element-249" data-mp="hic2kixwoetd">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}